import { createAction, props } from '@ngrx/store';
import { PaymentsBatch } from './payments-batch.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records payments-batch'
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records payments-batch success', 
    props<{ listData: PaymentsBatch[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records payments-batch failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state payments-batch',
);